import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import { RiArrowDropDownLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";

const PreviewIngredient = ({ trackHistory }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [expandedOrders, setExpandedOrders] = useState([]);

  const toggleExpand = (orderNo) => {
    setExpandedOrders((prev) =>
      prev.includes(orderNo)
        ? prev.filter((no) => no !== orderNo)
        : [...prev, orderNo]
    );
  };

  //   console.log(trackHistory);

  return (
    <div>
      <button
        onClick={() => setIsOpen(true)}
        className="bg-[#45cdf7] text-center text-white p-1 rounded-lg cursor-pointer"
      >
        <HiOutlineClipboardDocumentList className="lg:size-6 size-5" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[650px] w-[90%] max-h-[90vh] overflow-y-auto scrollbar-hide relative mx-auto space-y-3">
            <div className="flex justify-between sticky top-0 bg-white items-center border-b-2 border-[#DEDEDE] p-4 m-4 mt-0">
              <h1 className="md:text-[1.5rem] text-[1rem] font-bold text-[#0D868C]">
                Ingredient History
              </h1>
              <button type="button" onClick={() => setIsOpen(false)}>
                <FiX className="md:size-7 size-5 text-[#0D868C]" />
              </button>
            </div>
            <div className="m-6 flex flex-col gap-3 pb-6">
              {trackHistory?.length > 0 ? (
                trackHistory?.map((order, index) => (
                  <div
                    key={index}
                    className=" px-2 border-b py-1  shadow-sm rounded-md text-[#0D868C]"
                  >
                    <div
                      className="flex justify-between items-center cursor-pointer"
                      onClick={() => toggleExpand(order.orderNo)}
                    >
                      <h2 className="font-medium text-[.9rem]">
                        Order No: {order.orderNo}
                      </h2>
                      <span>
                        {expandedOrders.includes(order.orderNo) ? (
                          <RiArrowDropUpLine className="size-8" />
                        ) : (
                          <RiArrowDropDownLine className="size-8" />
                        )}
                      </span>
                    </div>

                    {expandedOrders.includes(order.orderNo) && (
                      <div className=" space-y-2 pl-2">
                        {order.products.map((product, i) => (
                          <div
                            key={i}
                            className="bg-gray-100 p-2 m-2 mb-4 rounded-md text-sm"
                          >
                            <p className=" capitalize">
                              Product: {product.productName}
                            </p>
                            <p className="">
                              Quantity: {product.productQuantity}
                            </p>
                            <p className="">
                              Ingredient Quantity: {product.ingredientQuantity}
                            </p>
                            <p className="">
                              Total used Quantity:{" "}
                              {product.ingredientQuantity *
                                product.productQuantity}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <span>No track history</span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PreviewIngredient;
